import React from 'react';
import { LoadingSpinner } from '@next-components/loading-spinner';

export const ColLoading = () => (
  <div style={{ marginTop: -10 }}>
    <LoadingSpinner size={28} />
  </div>
);
